import MobileOverrideButton from "components/Mobile/MobileOverrideButton";
import React from "react";

const MapLayout: React.FC = ({ children }) => {
  return (
    <div className="container-fluid map-container">
      {children}
      <MobileOverrideButton />
    </div>
  );
};

export default MapLayout;
